<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light shadow mb-1 bg-nav" id="navbar-head" data-aos="flip-up">
            <div class="container">
                <router-link class="navbar-brand" to="/"><img src="../../dist/logo.png" class="logo-nav"></router-link>
                <div class="navbar-toggler">
                    <a href="/check-out-product"><i class="fas fa-shopping-cart text-gray p-2"><span class="badge badge-danger font-12">{{$root.totalCart}}</span></i></a>
                    <button class="btn btn-link" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                </div>
                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav mr-auto">
                        <!-- <li class="nav-item">
                            <router-link class="nav-link" to="/products">สินค้าของเรา</router-link>
                        </li> -->
                        <li class="nav-item">
                            <router-link class="nav-link" to="/about">เกี่ยวกับเรา</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" to="/article">รวมบทความ</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" to="/contact">ติดต่อเรา</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link" to="/how-to-order">วิธีสั่งซื้อ</router-link>
                        </li>
                        <li v-show="$root.checkLoginCustomer" class="nav-item">
                            <router-link class="nav-link" to="/payment">แจ้งชำระเงิน</router-link>
                        </li>
                    </ul>
                    <a href="/check-out-product"><i class="fas fa-shopping-cart fa-2x cart-hiden text-gray p-2"><span class="badge badge-danger font-12">{{$root.totalCart}}</span></i></a>
                    <div class="d-flex">
                        <span class="p-2 text-bold">| ติดต่อเราได้ที่</span>
                        <div class="p-2" title="โทรหาเราเลย"><a href="Tel:000-000-0000"><i class="fas fa-phone-volume fa-2x text-primary"></i></a></div>
                        <div class="p-2" title="ติดต่อทาง Facebook"><i class="fab fa-facebook fa-2x text-facebook"></i></div>
                        <div class="p-2" title="ติดต่อทาง Line"><i class="fab fa-line fa-2x text-line"></i></div>
                        <div class="p-2">
                            <button v-if="!$root.checkLoginCustomer" class="btn btn-sm btn-primary" @click="modalUp()">เข้าสู่ระบบ</button>
                            <div v-else  class="dropdown">
                                <i class="fas fa-user-circle text-orange fa-2x" data-toggle="dropdown" :title="$root.keyusername_cus"></i>
                                <div class="dropdown-menu">
                                    <a class="dropdown-item" @click="$root.logoutCustomer()" href="#"><i class="fas fa-sign-out-alt"></i> ออกจากระบบ</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
        <div v-show="modal_login" class="modals">
            <div class="modal-content-login">
                <span class="closes" @click="modal_login=false">&times;</span>
                <h4 class="text-center mb-2">เข้าสู่ระบบเพื่อสั่งซื้อสินค้า</h4>
                <div class="row">
                    <div class="col-6">
                        <img :src="getImg()" class="img-fluid rounded">
                    </div>
                    <div class="col-6">
                        <form @submit.prevent="$root.loginCustomer()">
                            <div class="form-group">
                                <label>อีเมล</label>
                                <input type="email" v-model="$root.form_login_cus.email" v-validate="'required'" name="email" class="form-control" :class="{'input': true, 'is-invalid': errors.has('email') }" placeholder="อีเมล">
                                <i v-show="errors.has('email')" class="fas fa-warning"></i>
                                <span v-show="errors.has('email')" class="text-danger text-10">{{ errors.first('email') }}</span>
                            </div>
                            <div class="form-group">
                                <label>รหัสผ่าน</label>
                                <input type="password" v-model="$root.form_login_cus.password" v-validate="'required'" name="password" class="form-control" :class="{'input': true, 'is-invalid': errors.has('password')}" placeholder="รหัสผ่าน">
                                <i v-show="errors.has('password')" class="fas fa-warning"></i>
                                <span v-show="errors.has('password')" class="text-danger text-10">{{errors.first('password')}}</span>
                            </div>
                            <div class="form-group">
                                <button type="submit" class="btn btn-block bg-orange text-white">เข้าสู่ระบบ</button>
                            </div><hr>
                            <div class="form-group">
                                <router-link to="/register" class="btn btn-block btn-primary">ลงทะเบียน</router-link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.router-link-exact-active{
    background-color: #ffffff;
    color: rgb(0, 0, 0) !important;
    border-bottom: 5px solid #ff6700;
}
</style>
<script>
    export default {
        data(){
            return{
                modal_login: false
            }
        },
        methods:{
            getImg(){
                return '../../dist/typeProduct/20190513_1.jpg'
            },
            modalUp(){
                this.modal_login = true
            }
        },
        mounted(){
            this.$nextTick(function(){
                window.addEventListener("scroll", function(){
                var navbar = document.getElementById("navbar-head")
                var nav_classes = navbar.classList
                if(document.documentElement.scrollTop >= 200) {
                    if (nav_classes.contains("fixed-top") === false) {
                    nav_classes.toggle("fixed-top");
                    }
                }
                else {
                    if (nav_classes.contains("fixed-top") === true) {
                    nav_classes.toggle("fixed-top");
                    }
                }
                })
            })
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/Header.vue